import {
  GET_RESERVATION_SUCCESS,
  RESERVATION_LIST_REQUESTING,
  RESERVATION_OBJECT_REQUESTING,
  LIST_RESERVATIONS_SUCCESS,
  RESET_RESERVATION_ISFETCHING
  // RESET_RESERVATION_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false,
  query: null,
  recordCount: null
  // currentReservationId: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_RESERVATION_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    // case RESET_RESERVATION_QUERY: {
    //   return {
    //     ...state,
    //     query: null,
    //     recordCount: null
    //   };
    // }
    case RESERVATION_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case RESERVATION_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case LIST_RESERVATIONS_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        recordCount: action.payload.total,
        // currentReservationId: null,
        isListFetching: false
      };
    }
    case GET_RESERVATION_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        currentReservationId: action.payload.id,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
